var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompletion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.9492,
    height: 21.9971,
    viewBox: "0 0 19.9492 21.9971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.9492,0l-4,3.1,4,3.1V3.9971a7.9948,7.9948,0,0,1,2,15.7368v2.0616a10,10,0,0,0-2-19.7984Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.8887,6.8l-1.418-1.418A9.9435,9.9435,0,0,0,.0029,10.9971H2.0185A7.9461,7.9461,0,0,1,3.8887,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.9492,19.9971a7.9531,7.9531,0,0,1-4.582-1.4516L3.94,19.9717a9.9393,9.9393,0,0,0,6.0088,2.0254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.8838,17.1993a7.9654,7.9654,0,0,1-1.8653-4.2022H0a9.9471,9.9471,0,0,0,2.4707,5.6157Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletion);
export default __webpack_public_path__ + "static/media/completion.cff7b109bb6d8605bfa170134b23d10e.svg";
export { ForwardRef as ReactComponent };